/**
 * containerGroups constants
 */
export const CONTAINER_GROUP_LOAD_REQUESTED = 'CONTAINER_GROUP_LOAD_REQUESTED';
export const CONTAINER_GROUP_LOAD_SUCCEEDED = 'CONTAINER_GROUP_LOAD_SUCCEEDED';
export const CONTAINER_GROUP_LOAD_FAILED = 'CONTAINER_GROUP_LOAD_FAILED';

export const EVENT_LABELS_CREATE_REQUESTED = 'EVENT_LABELS_CREATE_REQUESTED';
export const EVENT_LABELS_CREATE_SUCCEEDED = 'EVENT_LABELS_CREATE_SUCCEEDED';
export const EVENT_LABELS_CREATE_FAILED = 'EVENT_LABELS_CREATE_FAILED';

export const CONTAINER_GROUPS_SET = 'CONTAINER_GROUPS_SET';
export const CONTAINER_GROUPS_MERGE = 'CONTAINER_GROUPS_MERGE';
export const CONTAINER_GROUP_SET = 'CONTAINER_GROUP_SET';

export const EVENT_LABELS_CANCEL_REQUESTED = 'EVENT_LABELS_CANCEL_REQUESTED';
export const EVENT_LABELS_CANCEL_SUCCEEDED = 'EVENT_LABELS_CANCEL_SUCCEEDED';
export const EVENT_LABELS_CANCEL_FAILED = 'EVENT_LABELS_CANCEL_FAILED';
